import * as React from 'react';
import {Select, FormLabel, VStack} from '@packages/systems/spring';
import {emotionStyled} from '@packages/utilities/styled';

type RiveSettingsOptionsTypeProps = {
  id: string;
  isDisabled?: boolean;
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: {label: string; value: string}[];
};

export const Label = emotionStyled(FormLabel)({width: '100%'});

export const RiveSettingsOptions = ({
  id,
  isDisabled,
  label,
  value,
  options,
  onChange,
}: RiveSettingsOptionsTypeProps) => {
  return (
    <VStack spacing={1}>
      <Label id={`rive-settings-rive-${label}-select-label`} htmlFor={id}>
        {label}
      </Label>
      <Select
        aria-label={label}
        data-automation-id={id}
        aria-labelledby={`rive-settings-${label}-select-label`}
        value={value}
        onChange={onChange}
        options={options}
        isDisabled={isDisabled || options.length === 0}
      />
    </VStack>
  );
};

RiveSettingsOptions.displayName = 'RiveSettingsOptions';
